<template>
   <div class='combined-graph-wrapper'>
      <input-field
         label="Select Energy"
         type="select"
         v-model="selectedEnergy"
         :options="energyOptions"
         :errors="[]"
         one-line
      />
      <div class="chart-wrapper">
         <chart :chart-data="chartOptions"/>
      </div>
   </div>
</template>

<script>
import Chart from '../../../../organisms/Home/Chart';
import InputField from '../../../../molecules/Login/InputField';
import { mapGetters } from 'vuex';
import { formatCurrency } from '../../../../../js/ui-helpers';

const xAxis = [{ categories: [], crosshair: true, }];
const commonYAxisProps = {
   labels: {
      formatter: function() {
         return formatCurrency(this.value, {withDecimals: false});
      },
   },
};
const yAxis = [
   { title: { text: 'Levelized Cost' }, ...commonYAxisProps },
   { title: { text: 'Life Cycle Cost' }, opposite: true, ...commonYAxisProps },
];
const tooltip = { 
   formatter: function ()
   {
      return this.points.reduce( (acc, point) =>
         {
            return `${acc}<br/>
               <span style="font-size: 1.4em; color:${point.series.color};">•</span>
               ${point.series.name}: <b>${formatCurrency(point.y)}</b>`;
         }, `${this.x}`);
   },
};

const series = [
   { name: 'Levelized Cost',  data: [], type: 'spline', yAxis: 0 },
   { name: 'Life Cycle Cost', data: [], type: 'spline', yAxis: 1 },
];

export default {
   name: 'combined-graphs',
   components: {
      Chart,
      InputField,
   },
   computed: {
      ...mapGetters(["getBatResults"]),
      chartOptions()
      {
         const results = this.getBatResults;
         console.assert(results, "no results");
         if (results)
         {
            const { levelized_costs,life_cycle_costs,years } = results.energy_costs[this.selectedEnergy].cost_series;
            xAxis[0].categories = [...years]; // have to use spread to remove unpredictive reference problems
            series[0].data = [...levelized_costs];
            series[1].data = [...life_cycle_costs];
         }
         return { title: this.getTitle(this.selectedEnergy), tooltip, xAxis, yAxis, series };
      },
      energyOptions()
      {
         const results = this.getBatResults;
         if (results)
         {
            const options = [
               {title: "Solar Home System",value: "shs"},
               {title: "Grid Extension",value: "grid"},
               {title: "Solar Mini-Grid",value: "solar_minigrid"},
            ];
            if (!results.is_in_terai)
            {
               options.push({title: "Mini Hydro Power",value: "mhp"});
            }
            return options;
         }
         return [];
      },
   },
   data() {
      return {
         selectedEnergy: "shs",
      };
   },
   methods: {
      getTitle(energy_code)
      {
         const codeToNameMap = {
            "shs": "Solar Home System",
            "mhp": "Mini Hydro Power",
            "grid": "Grid Extension",
            "solar_minigrid": "Solar Mini-Grid",
         };
         return { text: `${codeToNameMap[energy_code]}: Combine Graph of Life Cycle Cost and Levelized Cost`, y: 18, margin: 15 };

      }
   }
}
</script>

<style lang="scss" scoped>
.combined-graph-wrapper {
   height: 30em;
   display: flex;
   flex-direction: column;

   > div:first-child {
      width: max-content;
   }
   .chart-wrapper {
      flex: 1;
   }
}
</style>
